import api from 'api';

export const loadInfluencerChannelTable = api(
  'POST /api/influencers-channels/grid'
);

export const loadInfluencerChannelDetails = api(
  'GET /api/influencers-channels/:id/details'
);

export const loadInfluencerChannel = api('GET /api/influencers-channels/:id');

export const createInfluencerChannel = api('POST /api/influencers-channels');

export const updateInfluencerChannel = api('PUT /api/influencers-channels/:id');

export const deleteInfluencerChannel = api(
  'POST /api/influencers-channels/:id/delete'
);

export const exportInfluencerChannel = api(
  'POST /api/influencers-channels/export',
  {
    responseType: 'blob',
  }
);

export const uploadInfluencerChannel = api(
  `POST /api/influencers-channels/upload`
);

export const checkUploadInfluencersChannels = api(
  'GET /api/influencers-channels/upload/:jobId/status'
);
